package com.shadowings.gero.data.repository

import com.shadowings.gero.domain.repository.AnalyticsRepository
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.analytics.analytics

class AnalyticsRepositoryImpl : AnalyticsRepository {

    private val analytics get() = Firebase.analytics

    override fun logEvent(name: String, params: Map<String, Any>) {
        try {
            analytics.logEvent(name, params)
        } catch (e: Exception) {
            println("[ANALYTICS_ERROR] Failed to log event $name: ${e.message}")
        }
    }

    override fun setUserProperty(name: String, value: String) {
        try {
            analytics.setUserProperty(name, value)
        } catch (e: Exception) {
            println("[ANALYTICS_ERROR] Failed to set user property $name: ${e.message}")
        }
    }

    override fun logStartLesson(lessonId: String) {
        logEvent(
            name = "start_lesson",
            params = mapOf(
                "lesson_id" to lessonId,
            )
        )
    }

    override fun logStartQuiz(lessonId: String) {
        logEvent(
            name = "start_quiz",
            params = mapOf(
                "lesson_id" to lessonId,
            )
        )
    }

    override fun logWordViewed(wordId: String, meaning: String) {
        logEvent(
            name = "word_viewed",
            params = mapOf(
                "word_id" to wordId,
                "meaning" to meaning
            )
        )
    }

    override fun logHieroViewed(hieroId: String, unicode: String) {
        logEvent(
            name = "hiero_viewed",
            params = mapOf(
                "hiero_id" to hieroId,
                "unicode" to unicode
            )
        )
    }

    override fun logQuizCompleted(lessonId: String, score: Int, total: Int, errors: Int) {
        logEvent(
            name = "quiz_completed",
            params = mapOf(
                "lesson_id" to lessonId,
                "score" to score,
                "total" to total,
                "errors" to errors
            )
        )
    }

    override fun logFeaturePollResponse(option: String, freeText: String) {
        logEvent(
            name = "feature_poll_response",
            params = buildMap {
                put("option", option)
                if (freeText.isNotBlank()) {
                    // Firebase Analytics truncates/rejects string param values over 100 chars.
                    put("free_text", freeText.take(100))
                }
            }
        )
    }

    override fun logStatClicked(statType: String) {
        logEvent(
            name = "stat_clicked",
            params = mapOf(
                "stat_type" to statType
            )
        )
    }

    override fun logFavoriteToggled(wordId: String, isFavorite: Boolean) {
        logEvent(
            name = "favorite_toggled",
            params = mapOf(
                "word_id" to wordId,
                "is_favorite" to isFavorite
            )
        )
    }

    override fun logCharacterCustomized(character: String, category: String, colorIndex: Int) {
        logEvent(
            name = "character_customized",
            params = mapOf(
                "character" to character,
                "category" to category,
                "color_index" to colorIndex
            )
        )
    }

    override fun logCharacterReset(character: String) {
        logEvent(
            name = "character_reset",
            params = mapOf(
                "character" to character
            )
        )
    }

    override fun logSignOut() {
        logEvent(name = "sign_out")
    }

    override fun logTestModeToggled(enabled: Boolean) {
        logEvent(
            name = "test_mode_toggled",
            params = mapOf(
                "enabled" to enabled
            )
        )
    }

    override fun logDataReset() {
        logEvent(name = "data_reset")
    }

    override fun logTutorialStarted() {
        logEvent(name = "tutorial_started")
    }

    override fun logTutorialCompleted() {
        logEvent(name = "tutorial_completed")
    }

    override fun logSignUp() {
        logEvent(name = "sign_up")
    }

    override fun logLogin() {
        logEvent(name = "login")
    }

    override fun logSecurityThreat(threatType: String, details: String) {
        logEvent(
            name = "security_threat_detected",
            params = mapOf(
                "threat_type" to threatType,
                "details" to details
            )
        )
    }

    override fun logClickCompendio() {
        logEvent(name = "click_compendio")
    }

    override fun logClickBuilder() {
        logEvent(name = "click_builder")
    }

    override fun logClickPersonaggi() {
        logEvent(name = "click_personaggi")
    }

    override fun logClickProfilo() {
        logEvent(name = "click_profilo")
    }

    override fun logTabSimboli() {
        logEvent(name = "tab_simboli")
    }

    override fun logTabParole() {
        logEvent(name = "tab_parole")
    }

    override fun logTabRegole() {
        logEvent(name = "tab_regole")
    }

    override fun logTabImmagini() {
        logEvent(name = "tab_immagini")
    }

    override fun logTabAlyn() {
        logEvent(name = "tab_alyn")
    }

    override fun logTabNilo() {
        logEvent(name = "tab_nilo")
    }

    override fun logTabZeta() {
        logEvent(name = "tab_zeta")
    }

    override fun logTabMasko() {
        logEvent(name = "tab_masko")
    }
}
